import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title = "Confirmar acción",
  description = "",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  danger = false,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-black text-slate-900">
            {title}
          </DialogTitle>
        </DialogHeader>

        {description && (
          <div className="whitespace-pre-line text-sm font-semibold leading-relaxed text-slate-600">
            {description}
          </div>
        )}

        <DialogFooter className="gap-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            {cancelText}
          </Button>
          <Button
            type="button"
            onClick={() => {
              onConfirm?.();
              onOpenChange(false);
            }}
            className={danger ? "bg-red-600 text-white hover:bg-red-700" : "bg-[#4d7c0f] text-white hover:bg-[#3f6212]"}
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
